import { read } from './client.js';
import { useResource } from './resource.js';

export const spaceContextKey = (spaceId) => `space:${spaceId}:shared-context`;

const validPrefix = (value) => Array.isArray(value?.items) && value.items.length <= 10
  && Number.isInteger(value.total) && value.total >= value.items.length && typeof value.incomplete === 'boolean';
const validContext = (context, revision) => context === null ? revision === 0 : revision > 0
  && context?.revision === revision && typeof context.taskId === 'string'
  && Number.isInteger(context.versionNo) && context.versionNo > 0
  && typeof context.selectedVersion?.purpose === 'string'
  && ['confirmed', 'openQuestions', 'referenceIds'].every((key) => validPrefix(context.selectedVersion[key]));

export function useSpaceContext(spaceId, nodeId) {
  return useResource(spaceId && nodeId ? spaceContextKey(spaceId) : null, async (signal) => {
    const data = await read('space-context', { nodeId, signal, query: { spaceId } });
    if (data?.schemaVersion !== 1 || data.spaceId !== spaceId || !Number.isInteger(data.revision)
      || data.revision < 0 || typeof data.permissions?.canAdopt?.ok !== 'boolean'
      || !validContext(data.context, data.revision)) {
      throw new Error('이 공간의 공동 맥락을 확인하지 못했습니다.');
    }
    return data;
  }, { quiet: true, identity: nodeId });
}
